__turbopack_context__.v({
  "addToCartButton": "ProductServiceCard-module-scss-module__uvpM9a__addToCartButton",
  "bottom": "ProductServiceCard-module-scss-module__uvpM9a__bottom",
  "disabled": "ProductServiceCard-module-scss-module__uvpM9a__disabled",
  "image": "ProductServiceCard-module-scss-module__uvpM9a__image",
  "imageWrapper": "ProductServiceCard-module-scss-module__uvpM9a__imageWrapper",
  "list": "ProductServiceCard-module-scss-module__uvpM9a__list",
  "listItem": "ProductServiceCard-module-scss-module__uvpM9a__listItem",
  "price": "ProductServiceCard-module-scss-module__uvpM9a__price",
  "root": "ProductServiceCard-module-scss-module__uvpM9a__root",
  "title": "ProductServiceCard-module-scss-module__uvpM9a__title",
});
